const is_production = true;

const DEVELOPMENT_URL = "http://127.0.0.1:8000/api/";
const PRODUCTION_URL = "https://api.tripprizer.com/api/";

const PAYMENT_URL_DEVELOPMENT = "http://localhost:3002/";
const PAYMENT_URL_PRODUCTION = "https://www.payments.tripprizer.com/";

export const MAIN_URL = is_production ? PRODUCTION_URL : DEVELOPMENT_URL;

export const MAIN_PAYMENT_URL = is_production ? PAYMENT_URL_PRODUCTION : PAYMENT_URL_DEVELOPMENT;